import React from 'react';

import { Head, Layout } from '../components/layout';
import SubscribeForm from '../components/newsletter/subscribeForm';
import PdpIcon from '../components/product/pdpIcon';
import NEWSLETTER_ISSUES, { issueUrl } from '../lib/newsletterIssues';

// Press Sheet archive, docs/newsletter-archive.md. Layout follows "Press Sheet Archive — New Page"
// in design/website.pen. Issues are static email HTML in public/newsletter/, so rows link with a
// plain <a>, not next/link.
const NewsletterPage = () => (
  <>
    <Head
      title="Press Sheet Archive"
      description="Every roll of Press Sheet, the Parabo Press monthly newsletter with print ideas, photo tips and what’s new at Parabo."
      noindex
    />

    <Layout className="nla">
      <div className="nla-inner">
        <header className="nla-intro">
          <p className="nla-eyebrow">
            <span className="nla-eyebrow-label">Press Sheet</span>
            <span className="nla-eyebrow-rule" aria-hidden="true" />
            <span>Archive</span>
          </p>
          <h1 className="nla-h1">Every roll of Press Sheet</h1>
          <p className="nla-lead">
            Our monthly newsletter, with print ideas, photo tips and what’s new at Parabo. Read past
            issues here, or subscribe to get the next one in your inbox.
          </p>
          <SubscribeForm />
        </header>

        <section aria-label="Past issues">
          <ol className="nla-rolls">
            {NEWSLETTER_ISSUES.map((issue) => (
              <li key={issue.slug}>
                <a className="nla-roll" href={issueUrl(issue)}>
                  <span className="nla-roll-meta">
                    <span className="nla-roll-number">Roll {issue.roll}</span>
                    <span className="nla-roll-month">{issue.month}</span>
                  </span>
                  <span className="nla-roll-body">
                    <span className="nla-roll-title">{issue.title}</span>
                    <span className="nla-roll-theme">{issue.theme}</span>
                  </span>
                  <span className="nla-roll-read">
                    Read
                    <PdpIcon name="arrowRight" size={16} />
                  </span>
                </a>
              </li>
            ))}
          </ol>
          <p className="nla-rolls-note">A new roll is added here each month.</p>
        </section>
      </div>
    </Layout>
  </>
);

export default NewsletterPage;
